import { isMobile } from '../helpers/isMobile';

export const applicationsId = {
  174: {
    production: '113',
    development: '165',
  }
}

export const gameNameById = {
  174: "halloWin",
}

export const matricesByGameId = {
  174: {
    WinningLinesCoordinate: [
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
    ],
    allLineMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    symbolsMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
  },
};

// RU: каждый следующий тир доигрывает цепочку предыдущего и добавляет свой переход и петлю.
//     MAX (коэффициент упёрся в maxOdd) своих анимаций в риге не имеет — играет epic-цепочку.
const WIN_POPUP_CHAIN = [
  'bigStart',
  'bigLoop',
  'megaChange',
  'megaLoop',
  'superChange',
  'superLoop',
  'epicChange',
  'epicLoop',
];

// RU: точка хоста табло Win / Last Win ядра в координатах борда (центр нижнего края доски; доска —
//     спрайт gameBoard: веб 1105×800, телефон 540×497). Одно число y на платформу: подбирается по GPU.
//     Ядро одалживает хосту узел табло (`winLastWinConfigs.winLastWinLayer`), раскладка панели ядра
//     не меняется.
export const winPanelHostByGameId = {
  174: isMobile() ? { x: 270, y: 455 } : { x: 552.5, y: 712 },
};

// RU: пороги тиров и минимум показа — единые правила ядра (MG-49708: 10 / 20 / 50 / 100, max =
//     maxOdd, ниже 10× попапа нет); прежние свои 15 / 21 / 101 / 201 и минимум 15 сняты, как у
//     goldenTree. Сумма — bitmap-шрифтом `winPopupNumbers` frame-пака ядра.
export const winPopupConfigs = {
  // RU: попап ставится затемнением ядра: у рига нет костей background/scale2 для вписывания.
  needBlackLayerComponent: true,
  popupPosition: {
    x: isMobile() ? 0 : 720,
    y: isMobile() ? 480 : 405,
  },
  amountConfigs: {
    // RU: в риге PopUps слота суммы нет — сумма стоит по x/y намеренно.
    slot: null,
    type: 'bitMap',
    x: isMobile() ? 0 : 720,
    y: isMobile() ? 480 : 590,
    fontChangeLimit: 8,
    pivot: 1,
    style: { fontName: 'winPopupNumbers' },
    fontSizeBig: isMobile() ? 70 : 90,
    fontSizeSmall: isMobile() ? 80 : 80,
  },
  animationConfigs: {
    winPopupAnimation: [
      { type: 'BIG', duration: 4000, animationNames: WIN_POPUP_CHAIN.slice(0, 2) },
      { type: 'MEGA', duration: 6000, animationNames: WIN_POPUP_CHAIN.slice(0, 4) },
      { type: 'SUPER', duration: 8000, animationNames: WIN_POPUP_CHAIN.slice(0, 6) },
      { type: 'EPIC', duration: 11000, animationNames: WIN_POPUP_CHAIN.slice(0, 8) },
      { type: 'MAX', duration: 11000, animationNames: WIN_POPUP_CHAIN.slice(0, 8) },
    ],
  },
};

